import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import ConsumerSidebar, { ConsumerTopbar } from "@/components/ConsumerSidebar";

export default function ConsumerLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen flex bg-gray-50">
      <ConsumerSidebar open={open} onClose={() => setOpen(false)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <ConsumerTopbar onMenu={() => setOpen(true)} />
        <main className="flex-1 px-4 sm:px-6 lg:px-8 py-6 lg:py-8 max-w-[1400px] w-full mx-auto" data-testid="consumer-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
